<mat-toolbar class="mc-toolbar-normal" color="caution">
  <span class="mc-fill-remaining-flex-space"></span>
  <div class="mc-status-incident-bar-icon">
    <mat-icon class="mc-centered-text-icon" fontSet="project-titan" fontIcon="icon-warning-filled"></mat-icon>
  </div>
  <span class="mc-truncate mc-status-incident-bar-message">{{ message }}</span>
  <button mat-button class="mc-flex-shrink-0" (click)="onMoreInfoClicked()">More Information</button>
  <span class="mc-fill-remaining-flex-space"></span>
  <button mat-icon-button class="mc-flex-shrink-0" (click)="onDismissClicked()">
    <mat-icon fontSet="project-titan" fontIcon="icon-close"></mat-icon>
  </button>
</mat-toolbar>